import {
  Box,
  Typography
} from '@mui/material';
import Big from 'big.js';

import { CustomToolTip } from 'modules';
import { BarChartBase } from 'modules/components/layer01';
import { Tooltip } from 'recharts';



export type EpsBarChartProps = {
  data: {
    name: string;
    rate: number;
  }[];
  year: number;
  rangeMin: Big;
  rangeMax: Big;
  isFirst: boolean;
};

export const FC = (props: EpsBarChartProps) => {
  const annData = props.data.map((record) => {
    return {
      name: record.name,
      rate: record.rate.toString()
    };
  });

  const q1 = annData.find((node) => node.name.toLowerCase() === 'q1') ?? {
    name: 'Q1', rate: '0'
  };
  const q2 = annData.find((node) => node.name.toLowerCase() === 'q2') ?? {
    name: 'Q2', rate: '0'
  };
  const q3 = annData.find((node) => node.name.toLowerCase() === 'q3') ?? {
    name: 'Q3', rate: '0'
  };
  const q4 = annData.find((node) => node.name.toLowerCase() === 'q4') ?? {
    name: 'Q4', rate: '0'
  };

  return (
    <Box
      height='400px'
      sx={{
        display: 'flex',
        alignItems: 'flex-end'
      }}
    >
      <Box sx={{
        transform: `translate(${props.isFirst ? 0 : 20}px, -18px) rotateZ(270deg)`,
        width: 0,
        height: 0
      }}
      >
        <Typography variant='tabSectionTextBold'>
          {props.year}
        </Typography>
      </Box>

      <BarChartBase.FC
        yAxisFormatter={(value) => {
          return value.toLocaleString('en-US', {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
            currency: 'USD',
            style: 'currency',
            compactDisplay: 'short'
          });
        }}
        hideYAxis={!props.isFirst}
        data={[
          q1,
          q2,
          q3,
          q4
        ]}
        minY={props.rangeMin.toNumber()}
        maxY={props.rangeMax.toNumber()}
        toolTip={(
          <Tooltip
            cursor={{
              fill: 'transparent'
            }}
            offset={10}
            content={(
              <CustomToolTip.FC
                type='EPS'
                active={true}
                label='name'
                payload={[
                  q1,
                  q2,
                  q3,
                  q4
                ]}
              />
            )}
          />
        )}
      />
    </Box>
  );
};
